import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { responseHandler, sendData, socket } from "../../../store/actions";
import LayoutV2 from "../../../components/layout-v2";
import { constant, REGEX, SIGNUP_STEPS, SLUG_TYPE } from "../../../common/constant";
import UInput from "ubs-framework/v2/UInput";
import * as Icon from "ubs-icons"
import Validator from "simple-react-validator";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import UPopup from "ubs-framework/v2/UPopup";
import UCheckBox from "ubs-framework/v2/UCheckBox";
import useSocket from "../../common/useSocket";
import { withRouter } from "../../../common/hocs/routing-hoc";
import { isMobileDevice, spiltContact } from "ubs-framework/v2/common/function";
import { COLOR } from "ubs-framework/v2/common/constant";
import { createCookie, getCookie } from "ubs-framework/v2/common/function";
import { checkLowercase, checkMinLength, checkNumeric, checkSpecialCharacter, checkUppercase, isDisposableEmail } from "ubs-framework/v2/common/function";
import { isValidPhoneNumber } from 'libphonenumber-js';
import UCountryMobile from "ubs-framework/v2/UCountryMobile";
import ct from "countries-and-timezones";
import GTMHandler from "../../common/components/gtm-handler";

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

const SUBDOMAIN_LP_QUERY_KEY = "subdomainlp";
const SUBDOMAIN_LP_SESSION_KEY = "track_signup_subdomainlp";
const PARAMETER_PATH_QUERY_KEY = "parameter_path";
const PARAMETER_PATH_SESSION_KEY = "track_signup_parameter_path";

const TrackRegistration = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [passwordEye, setPasswordEye] = useState(false);
    const [hide, setHide] = useState(false)
    const _RD = useSelector(e => e?.common?.registerDetail)

    const forceUpdate = useForceUpdate()
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: { forceUpdate },
        validators: {
            uppercase: {  // name the rule
                message: 'Please use uppercase.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.upperCase) && params.indexOf(val) === -1
                },
            },
            lowercase: {  // name the rule
                message: 'Please use lowercase.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.lowerCase) && params.indexOf(val) === -1
                },
            },
            specialcase: {  // name the rule
                message: 'Please use one special character.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.specialChar) && params.indexOf(val) === -1
                },
            },
            number: {  // name the rule
                message: 'Please use one number.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.number) && params.indexOf(val) === -1
                },
            },
            not_disposable: {
                message: 'Disposable email addresses are not allowed.',
                rule: (val, params, validator) => {
                    return !isDisposableEmail(val);
                }
            },
            phone_valid: {
                message: 'Please enter a valid phone number.',
                rule: (val, params) => {
                    if (!val || !params[0]) return false;
                    try {
                        return isValidPhoneNumber(val, params[0]);
                    } catch {
                        return false;
                    }
                }
            }
        }
    }));

    const [errorMsg, setErrorMsg] = useState("");
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [showTogglePopup, setShowTogglePopup] = useState(false);
    const [toggle, setToggle] = useState(false)
    const [registerDetail, setRegisterDetail] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumberCC: "",
        phoneNumber: "",
        password: "",
        cpassword: "",
        referral: "",
    });


    // const tz = moment.tz.guess();
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const tzInfo = ct.getTimezone(tz);

    useEffect(() => {
        const countries = tzInfo?.countries?.map(code => ct.getCountry(code).name);
        const country = constant.COUNTRY_CODE?.find(_ => _.label === countries[0]);
        setRegisterDetail(prev => ({ ...prev, phoneNumberCC: country?.code, phoneNumber: country?.dial_code }));
    }, [tz]);

    useEffect(() => {
        if (!sessionStorage.getItem('is_registration_active')) {
            localStorage.removeItem('registerDetail');
            sessionStorage.setItem('is_registration_active', 'true');
        }

        const registerDetail = localStorage.getItem('registerDetail')
        if (registerDetail) {
            setRegisterDetail(JSON.parse(registerDetail))
        }
    }, [localStorage.getItem('registerDetail')])

    useEffect(() => {
        const queryParams = new URLSearchParams(props.location.search);
        const isSubdomainLp = queryParams.get(SUBDOMAIN_LP_QUERY_KEY) === "true";
        const hasActiveSignupFlow = !!(localStorage.getItem("signUpStep") || getCookie("signup_token"));

        if (isSubdomainLp) {
            sessionStorage.setItem(SUBDOMAIN_LP_SESSION_KEY, "true");
        } else if (!hasActiveSignupFlow) {
            sessionStorage.removeItem(SUBDOMAIN_LP_SESSION_KEY);
        }

        const parameterPath = queryParams.get(PARAMETER_PATH_QUERY_KEY);
        if (parameterPath) {
            sessionStorage.setItem(PARAMETER_PATH_SESSION_KEY, parameterPath);
        } else if (!hasActiveSignupFlow) {
            sessionStorage.removeItem(PARAMETER_PATH_SESSION_KEY);
        }
    }, [props.location.search]);

    // get referral Code
    useEffect(() => {
        const queryParams = new URLSearchParams(props.location.search);
        const affiliateCode = queryParams.get("referralcode");
        if (affiliateCode) {
            setRegisterDetail(prev => ({
                ...prev,
                referral: affiliateCode
            }));
        }
    }, [props.location.search]);

    const getSubdomainLpSearch = () => {
        const queryParams = new URLSearchParams(props.location.search);
        const isSubdomainLp = queryParams.get(SUBDOMAIN_LP_QUERY_KEY) === "true" || sessionStorage.getItem(SUBDOMAIN_LP_SESSION_KEY) === "true";

        return isSubdomainLp ? `?${SUBDOMAIN_LP_QUERY_KEY}=true` : "";
    }

    useEffect(() => {
        on();
        return () => off()
    }, [])

    const { on, off, refresh } = useSocket(res => {
        if (!res.error) {
            setDisabledBtn(false)
            switch (res.event) {
                case 'account|signUp': {
                    if (res?.data?.isUserExists) {
                        setErrorMsg('An account with this email address already exists.')
                    } else {
                        const slugType = localStorage.getItem('slugType') || 'track'
                        if (res?.data?.token) {
                            createCookie('signup_token', res?.data?.token, constant.COOKIE_DAYS)
                        }
                        if (res?.data?.signUpStep) {
                            localStorage.setItem('signUpStep', res?.data?.signUpStep)
                            if ([1]?.includes(res?.data?.signUpStep)) localStorage.setItem('registerDetail', JSON.stringify(res?.data))
                        }
                        if (res?.data?.orgInfo?.orgId) {
                            localStorage.setItem('signUpOrgId', res?.data?.orgInfo?.orgId)
                        }
                        if ([1]?.includes(res?.data?.signUpStep)) {
                            history.push(`/${slugType}/${SIGNUP_STEPS?.[res?.data?.signUpStep]}${getSubdomainLpSearch()}`)
                        }
                        else if ([2]?.includes(res?.data?.signUpStep)) history.push(`/${slugType}/${SIGNUP_STEPS?.[res?.data?.signUpStep]}${getSubdomainLpSearch()}`)
                        else if ([3, 4]?.includes(res?.data?.signUpStep)) history.push(`/${res?.data?.orgInfo?.orgId}/${slugType}/${SIGNUP_STEPS?.[res?.data?.signUpStep]}`)
                    }
                    break;
                }
                case 'checkEmailExistense': {
                    if (res.data.exists) {
                        setErrorMsg("An account with this email address already exists. Login or Register with different email")
                    }
                    break;
                }
                case "activateAccount": {
                    localStorage.removeItem('affiliatecode')
                    localStorage.removeItem('usercode')
                    history.push("/stay-tuned");
                    break;
                }
                default:
                    return true;
            }
        } else {
            setDisabledBtn(false)
            setErrorMsg(res.data.error);
            setTimeout(() => setErrorMsg(res.data.error), 5000);
        }
    })


    const inputEvent = (e) => {
        let { name, value } = e.target
        setRegisterDetail((val) => {
            return { ...val, [name]: value }
        })
    }

    const handle = {
        phoneField: (e) => {
            setRegisterDetail({ ...registerDetail, phoneNumber: e.phone, phoneNumberCC: e.code });
        }
    }

    const onSubmitAboutCompany = () => {
        const queryParams = new URLSearchParams(props.location.search);
        const utmInfo = {
            ...(queryParams.get('utm_source') && { utm_source: queryParams.get('utm_source') }),
            ...(queryParams.get('utm_medium') && { utm_medium: queryParams.get('utm_medium') }),
            ...(queryParams.get('utm_campaign') && { utm_campaign: queryParams.get('utm_campaign') }),
            ...(queryParams.get('parameter_path') && { parameter_path: queryParams.get('parameter_path') }),
        }

        const sendDetail = {
            firstName: registerDetail?.firstName,
            lastName: registerDetail?.lastName,
            email: registerDetail?.email,
            phone: registerDetail?.phoneNumber,
            countryCode: registerDetail?.phoneNumberCC,
            password: registerDetail?.password,
            ...(registerDetail?.referral && { referral: registerDetail?.referral }),
            apps: [localStorage.getItem('slugType') || SLUG_TYPE?.SUPERTRACK],
            utmInfo: utmInfo
        }

        if (validator?.current?.allValid() && toggle) {
            if (registerDetail?.cpassword !== registerDetail?.password) {
                setErrorMsg('Password and confirm password does not match')
            }
            else {
                setDisabledBtn(true);
                dispatch({ type: 'SET_EMAIL', payload: registerDetail?.email });
                sendData(dispatch, 'account|signUp', sendDetail);
            }
        } else {
            if (!toggle) {
                setErrorMsg('Please agree with Terms & Conditions and Privacy Policy')
            }
            validator?.current?.showMessages()
        }
    };


    const handleToggle = () => {
        setToggle(!toggle)
        if (!toggle) {
            setErrorMsg('')
        } else {
            setErrorMsg('Please agree with Terms & Conditions and Privacy Policy')
        }
    }

    const onKeyUp = e => {
        if (e.key === "Enter") {
            onSubmitAboutCompany()
        }
    }

    return (
        <React.Fragment>
            <GTMHandler />
            <LayoutV2 module="">
                <div className="u_p-24">
                    <div>
                        <div className="u_flex u_content-center">
                            <img src="/images/images/track-logo.png" />
                        </div>
                        <h3 className="u_title u_text-center u_text-bold u_my-16">Create a new account</h3>

                        {/* <div className="u_row u_content-center u_mt-24">
                            <div className="u_border-radius-8 u_b-light u_mr-8 u_p-10">
                                <Icon.Google size="18" />
                            </div>
                            <div className="u_border-radius-8 u_b-light u_mr-8 u_p-10">
                                <Icon.Apple size="18" fill={COLOR.u_title} />
                            </div>
                            <div className="u_border-radius-8 u_b-light u_mr-8 u_p-10">
                                <Icon.Microsoft size="18" />
                            </div>
                            <div className="u_border-radius-8 u_b-light u_mr-8 u_p-10">
                                <Icon.Linked size="18" fill="#0073C5" />
                            </div>
                            <div className="u_border-radius-8 u_b-light u_p-10">
                                <Icon.Facebook size="18" fill={COLOR.u_blue} />
                            </div>
                        </div>

                        <div className="u_or-divider">
                            <p className="u_small-font u_px-16">OR</p>
                        </div> */}
                    </div>

                    <div className="u_row u_mt-24">
                        <div className="u_col-6">
                            <UInput
                                hasError={validator?.current?.message("firstName", registerDetail?.firstName, "required")}
                                className="u_mb-20"
                                label="First Name"
                                asterisk
                                testId={TEST_ID.TRACK_REGISTRATION.INPUT_WRAPPER}>
                                <input
                                    name="firstName"
                                    value={registerDetail?.firstName}
                                    onChange={inputEvent}
                                    placeholder=" "
                                    onKeyUp={onKeyUp}
                                    autoComplete="off"
                                    data-testid={TEST_ID.TRACK_REGISTRATION.FIRST_NAME_INPUT} />
                            </UInput>
                        </div>

                        <div className="u_col-6">
                            <UInput
                                hasError={validator?.current?.message("lastName", registerDetail?.lastName, "required")}
                                className="u_mb-20"
                                label="Last Name"
                                asterisk
                                testId={TEST_ID.TRACK_REGISTRATION.INPUT_WRAPPER}>
                                <input
                                    name="lastName"
                                    value={registerDetail?.lastName}
                                    onChange={inputEvent}
                                    placeholder=" "
                                    onKeyUp={onKeyUp}
                                    autoComplete="off"
                                    data-testid={TEST_ID.TRACK_REGISTRATION.LAST_NAME_INPUT} />
                            </UInput>
                        </div>

                        <div className="u_col-12">
                            <UInput
                                hasError={validator?.current?.message("email", registerDetail?.email, "required|email|not_disposable")}
                                className="u_mb-20"
                                label="Email Address"
                                asterisk
                                testId={TEST_ID.TRACK_REGISTRATION.INPUT_WRAPPER}>
                                <input
                                    name="email"
                                    value={registerDetail?.email}
                                    onChange={inputEvent}
                                    placeholder=" "
                                    onKeyUp={onKeyUp}
                                    autoComplete="new-email"
                                    data-testid={TEST_ID.TRACK_REGISTRATION.EMAIL_INPUT} />
                            </UInput>
                        </div>

                        <div className="u_col-12">
                            <UInput label="Phone Number"
                                className="u_mb-20" isFocused asterisk
                                hasError={validator?.current?.message("phoneNumber", spiltContact(registerDetail?.phoneNumber)[1], `required|phone_valid:${registerDetail?.phoneNumberCC}`)}>

                                <UCountryMobile code={registerDetail?.phoneNumberCC} phone={registerDetail?.phoneNumber}
                                    onChange={handle.phoneField} />
                            </UInput>
                        </div>

                        <div className="u_col-12">
                            <UInput
                                className="u_mb-20"
                                password
                                label="New Password"
                                asterisk
                                hasError={validator?.current?.message("password", registerDetail?.password, "required|min:8|uppercase|lowercase|specialcase|number")}
                                testId={TEST_ID.TRACK_REGISTRATION.INPUT_WRAPPER}>
                                <input
                                    onChange={inputEvent}
                                    value={registerDetail.password}
                                    onKeyUp={onKeyUp}
                                    type={`${passwordEye ? "text" : "password"}`}
                                    autoComplete="new-password"
                                    name="password"
                                    placeholder=" "
                                    data-testid={TEST_ID.TRACK_REGISTRATION.PASSWORD_INPUT} />
                                <div className="u_input-note u_ib">
                                    <UPopup params={{ className: "u_tooltip u_tooltip-full", disabled: isMobileDevice() }}
                                        desc={<span>{!passwordEye ? "Show Password" : "Hide Password"} </span>}>

                                        <span className="u_rollover u_cp u_flex" onClick={() => setPasswordEye(!passwordEye)} data-testid={TEST_ID.SIGNUP_REGISTRATION.PASSWORD_TOGGLE} >{!passwordEye ?
                                            <Icon.HideEye size={18} fill={COLOR.u_icon_bg} /> :
                                            <Icon.Eye size={18} fill={COLOR.u_icon_bg} />}</span>
                                    </UPopup>
                                </div>
                            </UInput>
                        </div>

                        <div className="u_col-12">
                            <UInput
                                className="u_mb-20"
                                label="Confirm Password"
                                password
                                asterisk
                                hasError={validator?.current?.message('ConfirmPassword', registerDetail?.cpassword, 'required|min:8|uppercase|lowercase|specialcase|number')}
                                testId={TEST_ID.TRACK_REGISTRATION.INPUT_WRAPPER}>
                                <input
                                    onChange={inputEvent}
                                    value={registerDetail?.cpassword}
                                    name="cpassword"
                                    onKeyUp={onKeyUp}
                                    type={`${hide ? 'text' : 'password'}`}
                                    autoComplete="new-password"
                                    placeholder=" "
                                    data-testid={TEST_ID.TRACK_REGISTRATION.CONFIRM_PASSWORD_INPUT} />
                                <div className="u_input-note u_ib">
                                    <UPopup params={{ className: 'u_tooltip u_tooltip-full', disabled: isMobileDevice() }}
                                        desc={<span>{!hide ? 'Show Password' : 'Hide Password'} </span>}>

                                        <span className="u_rollover u_cp u_flex" onClick={() => setHide(!hide)} data-testid={TEST_ID.SIGNUP_REGISTRATION.PASSWORD_TOGGLE} >{!hide ?
                                            <Icon.HideEye size={18} fill={COLOR.u_icon_bg} /> :
                                            <Icon.Eye size={18} fill={COLOR.u_icon_bg} />}</span>
                                    </UPopup>
                                </div>
                            </UInput>
                        </div>

                        <div className="u_col-12">
                            <UInput
                                className="u_mb-20"
                                label="Referral Code"
                                testId={TEST_ID.TRACK_REGISTRATION.INPUT_WRAPPER}>
                                <input
                                    name="referral"
                                    value={registerDetail?.referral}
                                    onChange={inputEvent}
                                    placeholder=" "
                                    onKeyUp={onKeyUp}
                                    autoComplete="off"
                                    data-testid={TEST_ID.TRACK_REGISTRATION.REFERRAL_INPUT} />
                            </UInput>
                        </div>
                    </div>

                    <div className={`u_reset-content ${errorMsg ? 'u_mb-0' : 'u_mb-10'}`}>
                        <ul className="u_flex u_flex-wrap">
                            <li style={{ color: `${checkMinLength(registerDetail.password, 8) ? '#60B158' : '#8F95A6'}` }}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                    fill={`${checkMinLength(registerDetail.password, 8) ? '#60B158' : '#8F95A6'} `} />Minimum
                                8 Characters
                            </li>
                            <li style={{ color: `${checkUppercase(registerDetail.password) ? '#60B158' : '#8F95A6'} ` }}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                    fill={`${checkUppercase(registerDetail.password) ? '#60B158' : '#8F95A6'} `} />Uppercase
                            </li>
                            <li style={{ color: `${checkLowercase(registerDetail.password) ? '#60B158' : '#8F95A6'} ` }}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                    fill={`${checkLowercase(registerDetail.password) ? '#60B158' : '#8F95A6'} `} />Lowercase
                            </li>
                            <li style={{ color: `${checkNumeric(registerDetail.password) ? '#60B158' : '#8F95A6'} ` }}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                    fill={`${checkNumeric(registerDetail.password) ? '#60B158' : '#8F95A6'} `} />1
                                Numeric Number
                            </li>
                            <li style={{ color: `${checkSpecialCharacter(registerDetail.password) ? '#60B158' : '#8F95A6'} ` }}>
                                <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                    fill={`${checkSpecialCharacter(registerDetail.password) ? '#60B158' : '#8F95A6'} `} />1
                                Special Character
                            </li>
                        </ul>
                    </div>

                    <div className="u_mb-20 u_flex u_terms-conditions">
                        <UPopup showDefault={showTogglePopup} params={{ className: "u_tooltip" }}
                            desc={<span>Please agree with Terms & Conditions and Privacy Policy</span>}>
                            <span><UCheckBox
                                id="123"
                                label=""
                                checked={toggle}
                                onChange={handleToggle}
                                testId={TEST_ID.TRACK_REGISTRATION.CHECKBOX} /></span></UPopup>
                        <p
                            className="u_small-font">Agree
                            with <a
                                href="https://superworks.com/terms-and-conditions"
                                target="_blank"
                                className="u_small-font"
                                data-testid={TEST_ID.TRACK_REGISTRATION.LINK}>Terms & Condition </a> and <a
                                    href="https://superworks.com/privacy-policy"
                                    target="_blank"
                                    className="u_small-font"
                                    data-testid={TEST_ID.TRACK_REGISTRATION.LINK}> Privacy Policy</a></p>
                    </div>

                    {errorMsg?.length !== 0 && (
                        <p className="u_error-message u_mb-15">{errorMsg}</p>
                    )}
                    <div className="u_block u_relative">
                        <button
                            disabled={disabledBtn}
                            type="button"
                            onClick={onSubmitAboutCompany}
                            className={`u_acc-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}
                            data-testid={TEST_ID.TRACK_REGISTRATION.BUTTON}>Sign Up
                        </button>
                        {disabledBtn &&
                            <div className="u_btn-loader"><Icon.Preloader size={70} /></div>}
                    </div>

                    <p className="u_send-code u_t-center u_mt-24">Already have an account? <span className="u_cp" onClick={e => history.push('/login?slugType=track')} data-testid={TEST_ID.COMMON.LOGIN_REDIRECT_LINK} >Sign In</span></p>
                </div>
            </LayoutV2>
        </React.Fragment>
    );
}

export default withRouter(TrackRegistration);
